import { createGetApi } from "@api/util/createGetApi";

import type { IApiResponse } from "@api";
import type { IPurchaseInvoiceItemReportGetAllParams } from "@api/stores/purchaseInvoiceItemReport/types";

import type { IPathBaseParam } from "./path";
import type { IPurchaseInvoiceItemReportStatsResponse } from "./types";

const getApis = createGetApi<
  IApiResponse<IPurchaseInvoiceItemReportStatsResponse>,
  IPathBaseParam,
  IPurchaseInvoiceItemReportGetAllParams
>("stores.purchaseInvoiceItemReport.stats");

export const stats = {
  ...getApis,
};
